import styled from "styled-components"
import GenericModal from "components/modal"
import { maxWidth } from "utils"

export const Modal = styled(GenericModal)`
  margin-top: 6.8rem;
  background: #222;
  width: 100%;
  height: 100vh;
  display: flex;

  align-items: center;
  justify-content: center;

  ${maxWidth.mobile`
    margin-top: 6.6rem;
  `}
`

export const Content = styled.div`
  width: 70%;
  color: ${(props) => props.theme.colors.text.alternate};

  ${maxWidth.tablet`
    width: 85%;
  `}

  ${maxWidth.mobile`
    width: 100%;
  `}
`

export const TopRow = styled.div`
  text-align: right;
`
